export enum EnumCriteriaCode {
    nld_so_dinh_danh = 'nld_so_dinh_danh',
    nld_ho_ten = 'nld_ho_ten',
    nld_quoc_tich = 'nld_quoc_tich',
    nld_ngay_sinh = 'nld_ngay_sinh',
    nld_gioi_tinh = 'nld_gioi_tinh',
    nld_dia_chi = 'nld_dia_chi',
    nld_so_dien_thoai = 'nld_so_dien_thoai',
    nld_email = 'nld_email',
    nld_ma_bhxh = 'nld_ma_bhxh',
    nld_chung_chi_hanh_nghe = 'nld_chung_chi_hanh_nghe',

    ndd_so_dinh_danh = 'ndd_so_dinh_danh',
    ndd_ho_ten = 'ndd_ho_ten',
    ndd_quoc_tich = 'ndd_quoc_tich',
    ndd_ngay_sinh = 'ndd_ngay_sinh',
    ndd_gioi_tinh = 'ndd_gioi_tinh',
    ndd_dia_chi = 'ndd_dia_chi',
    ndd_so_dien_thoai = 'ndd_so_dien_thoai',
    ndd_email = 'ndd_email',
    ndd_ma_bhxh = 'ndd_ma_bhxh',
    ndd_quan_he_nld = 'ndd_quan_he_nld',

    tthd_cong_viec_chuc_vu ='tthd_cong_viec_chuc_vu',
    tthd_vi_tri = 'tthd_vi_tri',
    tthd_dia_diem_lam_viec = 'tthd_dia_diem_lam_viec',
    tthd_loai_tien_te = 'tthd_loai_tien_te',
    tthd_muc_luong = 'tthd_muc_luong',

    pcl_chuc_vu = 'pcl_chuc_vu',
    pcl_tham_nien_khung = 'pcl_tham_nien_khung',
    pcl_tham_nien_nghe = 'pcl_tham_nien_nghe',
    pcl_luong = 'pcl_luong',
    pcl_cac_khoan_bo_sung = 'pcl_cac_khoan_bo_sung',
    
    nndh_is_doc_hai = 'nndh_is_doc_hai',
    nndh_bat_dau = 'nndh_bat_dau',
    nndh_ket_thuc = 'nndh_ket_thuc',
    loai_hop_dong = 'loai_hop_dong',
    so_thang_thuc_hien = 'so_thang_thuc_hien',
    ma_hop_dong = 'ma_hop_dong',
    ngay_ket_thuc_hdld = 'ngay_ket_thuc_hdld',
    loai_bao_cao = 'loai_bao_cao',
    ngay_bat_dau_hdld = 'ngay_bat_dau_hdld',
    thoi_gian_bat_dau_dong_bhxh = 'thoi_gian_bat_dau_dong_bhxh',
    thoi_gian_ket_thuc_dong_bhxh = 'thoi_gian_ket_thuc_dong_bhxh',
    che_do_nang_luong = 'che_do_nang_luong',
    ky_han_tra_luong = 'ky_han_tra_luong',
    hinh_thuc_tra_luong = 'hinh_thuc_tra_luong',
    che_do_phuc_loi = 'che_do_phuc_loi',
    phuong_thuc_ky = 'phuong_thuc_ky',
    ly_do = 'ly_do',
    ngay_ket_thuc_hop_dong_moi = 'ngay_ket_thuc_hop_dong_moi',
    ngay_cham_dut_hop_dong = 'ngay_cham_dut_hop_dong',
    ngay_ap_dung_dia_diem_moi = 'ngay_ap_dung_dia_diem_moi'
}